import React, { useEffect } from "react";
import { browserName } from "react-device-detect";
import logo from '../../assets/icons/logo.svg';
import { useSearchParams } from "react-router-dom";
import { getFileUrl } from "../../routes/clientUrls";
import InstructionStep from "../../components/InstructionStep";
import { getFirstStepInstruction, InstractionSteps } from "../../utils/helpers";

import styles from './DownloadFile.module.css';

const DownloadFile: React.FC = () => {
  const [searchParams] = useSearchParams();
  const fn = searchParams.get("fn");

  const downloadFile = () => {
    if (!fn) return;

    const link = document.createElement('a');
    link.href = getFileUrl(fn);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    downloadFile();
  }, []);

  const { step2, step3 } = InstractionSteps;
  const step1 = getFirstStepInstruction(browserName, fn)

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <img src={logo} alt="logo" />
      </div>
      <div className={styles.title}>
        Thank you for downloading the installer.<br className={styles.br} />&nbsp;
        We are almost there!
      </div>
      <div className={styles.subTitle}>
        The download will start automatically. If this does not happen,&nbsp;
        <span className={styles.downloadLink}
          onClick={downloadFile}
        >
          download Velox Viewer manually.
        </span>
      </div>
      <div className={styles.steps}>
        <InstructionStep
          label={step1.label}
          title={step1.title}
          instruction={step1.instruction}
          imgSrc={step1.imgSrc}
        />
        <InstructionStep
          label={step2.label}
          title={step2.title}
          instruction={step2.instruction}
          imgSrc={step2.imgSrc}
        />
        <InstructionStep
          label={step3.label}
          title={step3.title}
          instruction={step3.instruction}
          imgSrc={step3.imgSrc}
        />
      </div>
    </div>
  );
};

export default DownloadFile;